import { AUTH_ENDPOINTS } from '../../../utils/api/endpoints/authEndpoints';
import {
  UseForgotPasswordDataParams,
  UseForgotPasswordDataResponse,
} from './useForgotPasswordData.types';

const PREFIX = '[forgotPasswordDataQuery]';

export const queryForgotPasswordData = async (params: UseForgotPasswordDataParams) => {
  console.log(PREFIX, `Fetching forgot password data...`);
  const response = await AUTH_ENDPOINTS.getForgotPasswordData(params);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received forgot password data.`);
  return json as UseForgotPasswordDataResponse;
};
